import * as React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import formatDate from 'date-fns/format';
import { CustomerAgreementListItem } from '../types';
import { Translate } from '../../../shared/LanguageService';

type CustomerAgreementsListProps = {
    customerAgreements: CustomerAgreementListItem[];
    canEdit: boolean;
    onEdit: (customerAgreement: CustomerAgreementListItem) => void;
};

export function CustomerAgreementsList({
    customerAgreements,
    canEdit,
    onEdit
}: CustomerAgreementsListProps) {
    if (customerAgreements.length === 0) {
        return (
            <Typography variant="body1">{Translate('customer-agreements/list/empty')}</Typography>
        );
    }

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{Translate('customer-agreements/list/header/name')}</TableCell>
                    <TableCell>{Translate('customer-agreements/list/header/version')}</TableCell>
                    <TableCell>{Translate('customer-agreements/list/header/updated')}</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {customerAgreements.map((customerAgreement) => (
                    <TableRow
                        key={customerAgreement.id}
                        data-inactive={customerAgreement.isActive ? undefined : 'true'}
                        sx={{
                            '&[data-inactive="true"]': {
                                backgroundColor: 'action.hover'
                            },
                            '&[data-inactive="true"] td': {
                                color: 'text.disabled'
                            }
                        }}
                    >
                        <TableCell>
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: '700', fontSize: '16px' }}
                            >
                                {customerAgreement.name}
                            </Typography>
                        </TableCell>
                        <TableCell>{customerAgreement.versionNumber}</TableCell>
                        <TableCell>
                            {formatDate(
                                new Date(customerAgreement.versionCreatedAt),
                                'yyyy-MM-dd HH:mm'
                            )}
                        </TableCell>
                        <TableCell>
                            {canEdit ? (
                                <Button
                                    startIcon={<EditIcon />}
                                    variant="outlined"
                                    sx={{ backgroundColor: 'background.paper' }}
                                    onClick={() => onEdit(customerAgreement)}
                                >
                                    <Typography variant="body1">{Translate('edit')}</Typography>
                                </Button>
                            ) : null}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
